import { DataTableColumn } from "../../../shared/components/data-table/DataTableColumn.model";

export interface Underwriter {
    id: number;
    account_id?: number;
    name: string;
    description: string;
    is_active?: boolean;
    created_date?: Date;
    updated_date?: Date;
}

export const UnderwritersColumns: DataTableColumn[] = [
    { column: 'id', display: 'ID' },
    { column: 'name', display: 'Name' },
    { column: 'description', display: 'Description' },
    { column: 'underwriterButtons', display: '' }
]